export const TELL_US_MORE_MAX_LENGTH = 100;
export const OTHER_PROVIDER_DETAILS = 'otherProviderDetails';
export const OTHER_LOCATION_DETAILS = 'otherLocationDetails';
